export const tenantId = '2edaeb8d-8b0c-4891-b7dc-8c1a333f25c0';
export const clientId = 'e02dc5f0-4f7f-404c-99ee-1e4cdf6745d7';
export const version = '0.0.3';
export const apiUrl = 'https://coc00napi.azurewebsites.net/api/';
export const apiScope = 'api://coc00n_api/read';
export const apiRedirectUrl = [...apiUrl.split('/').slice(0, 3), '.auth/login/aad'].join('/');
export const appUrl = 'app.coc00n.com';
